import _pt from "prop-types";
import React from 'react';
import * as Styled from './ColourAndFabricPicker.styles';
import FabricTag from '../FabricTag/FabricTag';
import AvailableIcon from '../AvailableIcon/AvailableIcon';
import { getColourFabricImage, groupByTypeValue, sortByOrderArray, getProductAttributes, getDisplayPriceByFabric } from '../../helpers';
import { fabrics as fabricConfig } from '../../config';
import { UPDATE_PRODUCT } from '../../types';

var ColourAndFabricPicker = function ColourAndFabricPicker(props) {
  var productVariants = props.productVariants,
      selectedProduct = props.selectedProduct,
      currentVariant = props.currentVariant,
      dispatch = props.dispatch;
  var currentProductAttributes = getProductAttributes(currentVariant); // The current product on the page
  // Only get product variants that match the current products feet colour and size

  var filteredVariants = productVariants.filter(function (product) {
    var variantAttributes = getProductAttributes(product);
    return variantAttributes['Feet colour'] === currentProductAttributes['Feet colour'] && variantAttributes.Size === currentProductAttributes.Size;
  }); // Group and order the product variants by fabric type

  var groupedFabric = groupByTypeValue(filteredVariants, 'Fabric type', 'value');
  var variantsByFabric = sortByOrderArray(groupedFabric);
  if (!Object.keys(variantsByFabric).length) return null;
  var fabrics = Object.keys(variantsByFabric);
  return /*#__PURE__*/React.createElement(React.Fragment, null, fabrics.map(function (fabric) {
    var _fabricConfig$find;

    var groupedFabricColours = groupByTypeValue(variantsByFabric[fabric], 'Colour', 'value');

    var _getDisplayPriceByFab = getDisplayPriceByFabric(variantsByFabric[fabric]),
        price = _getDisplayPriceByFab.price,
        isIdentical = _getDisplayPriceByFab.isIdentical;

    var fabricTags = (fabricConfig === null || fabricConfig === void 0 ? void 0 : (_fabricConfig$find = fabricConfig.find(function (fabricConfigItem) {
      return (fabricConfigItem === null || fabricConfigItem === void 0 ? void 0 : fabricConfigItem.heading) === fabric;
    })) === null || _fabricConfig$find === void 0 ? void 0 : _fabricConfig$find.tags) || [];
    var formattedPrice = price === null || price === void 0 ? void 0 : price.toFixed(2);
    return /*#__PURE__*/React.createElement(Styled.Container, {
      key: fabric
    }, /*#__PURE__*/React.createElement(Styled.Header, null, /*#__PURE__*/React.createElement(Styled.Title, {
      "data-test": "colour-fabric-title"
    }, fabric), /*#__PURE__*/React.createElement(Styled.Price, {
      "data-test": "colour-fabric-price"
    }, isIdentical ? "\xA3".concat(formattedPrice) : "From \xA3".concat(formattedPrice))), fabricTags.length > 0 && /*#__PURE__*/React.createElement(Styled.TagContainer, null, fabricTags.map(function (tag) {
      return /*#__PURE__*/React.createElement(FabricTag, {
        key: tag,
        label: tag
      });
    })), /*#__PURE__*/React.createElement(Styled.Tiles, null, Object.keys(groupedFabricColours).map(function (colour) {
      var product = groupedFabricColours[colour][0];
      var isSelected = (selectedProduct === null || selectedProduct === void 0 ? void 0 : selectedProduct.partNumber) === product.partNumber;

      var _getColourFabricImage = getColourFabricImage(colour, fabric),
          src = _getColourFabricImage.src,
          alt = _getColourFabricImage.alt,
          height = _getColourFabricImage.height,
          width = _getColourFabricImage.width,
          cropParams = _getColourFabricImage.cropParams;

      return /*#__PURE__*/React.createElement(Styled.TileContainer, {
        key: colour
      }, /*#__PURE__*/React.createElement(Styled.Tile, {
        onClick: function onClick() {
          dispatch({
            type: UPDATE_PRODUCT,
            payload: product
          });
        },
        "data-test": "colour-fabric-tile"
      }, /*#__PURE__*/React.createElement(Styled.Image, {
        src: src,
        width: width,
        height: height,
        alt: alt,
        $isSelected: isSelected,
        cropParams: cropParams
      }), isSelected && /*#__PURE__*/React.createElement(AvailableIcon, null)), /*#__PURE__*/React.createElement(Styled.TileText, {
        "data-test": "colour-fabric-tile-text"
      }, colour));
    })));
  }));
};

ColourAndFabricPicker.propTypes = {
  productVariants: _pt.array.isRequired
};
export default ColourAndFabricPicker;